// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"618":"56b8da4bc492da3d","684":"d36038a121c84cef"}[chunkId] + ".js";
};